import { render, staticRenderFns } from "./settingProduct.vue?vue&type=template&id=59ffd2a2&scoped=true"
import script from "./settingProduct.vue?vue&type=script&lang=js"
export * from "./settingProduct.vue?vue&type=script&lang=js"
import style0 from "./settingProduct.vue?vue&type=style&index=0&id=59ffd2a2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ffd2a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59ffd2a2')) {
      api.createRecord('59ffd2a2', component.options)
    } else {
      api.reload('59ffd2a2', component.options)
    }
    module.hot.accept("./settingProduct.vue?vue&type=template&id=59ffd2a2&scoped=true", function () {
      api.rerender('59ffd2a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplier/coupons/settingProduct.vue"
export default component.exports